module.exports = __webpack_public_path__ + "static/media/icon-track-assignment-assigned-by-others-active.657edd52.svg";